import { Plus } from 'lucide-react';

interface KeysHeaderProps {
  onCreateKey: () => void;
  keyCount: number;
  keyLimit: number;
  isLoading: boolean;
}

export function KeysHeader({ onCreateKey, keyCount, keyLimit, isLoading }: KeysHeaderProps) {
  const hasReachedLimit = keyCount >= keyLimit;

  return (
    <div className="flex flex-col xl:flex-row xl:items-center gap-4 mb-6">
      <button
        onClick={onCreateKey}
        disabled={hasReachedLimit}
        className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg w-fit transition-all duration-200 shadow-sm ${
          hasReachedLimit
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-gray-700 dark:text-gray-500'
            : 'bg-[#E34290] text-white hover:bg-[#D63384] hover:shadow-md focus:ring-2 focus:ring-[#E34290] focus:ring-offset-2 dark:focus:ring-offset-gray-800'
        }`}
        title={hasReachedLimit ? 'Delete unused keys to create new ones' : 'Create a new API key'}
        data-ph-capture-attribute="btn-keys-header-create"
      >
        <Plus className="h-4 w-4 mr-2" />
        New API Key
      </button>

      {!isLoading && (
        <div className="text-sm text-gray-600 dark:text-gray-300">
          <span>
            API Keys:{' '}
            <span className="font-medium">
              {keyCount}/{keyLimit}
            </span>
          </span>
          {hasReachedLimit && (
            <span className="block xl:inline xl:ml-2 text-red-600">
              Delete unused keys to create new ones
            </span>
          )}
        </div>
      )}
    </div>
  );
}
